import { useMemo } from "react";
import { InfoSectionDoubleForm } from "src/components/common/form/infoSectionDoubleForm";
import { SearchDropDownForm } from "src/components/common/form/search/SearchDropDownForm";
import { SysCodeDto } from "src/dtos/code/sysCodeDto";
import { WareHouseDto } from "src/dtos/warehouse/wareHouseDto";
import { useCommonCodeStore } from "src/store/useCommonCodeStore";
import { processTypeMap_WMS2020_R01, useWMS2020_R01Store } from "./Store_WMS2020_R01";
import { SearchRadioButtonForm } from "src/components/common/form/search/SearchRadioButtonForm";

interface Props {}

export const InfoSection_WMS2020_R01 = ({}: Props) => {
    const {
        WMS2020_R01ProcessFilter,
        setWMS2020_R01ProcessFilter
    } = useWMS2020_R01Store();

    const {
        wmsCdList,   	
        warehouseCdList,
        brandCdList     
    } = useCommonCodeStore();

	const warehouseCdListToUse = useMemo(() => {
		return warehouseCdList.filter(value => value.logicCenter === WMS2020_R01ProcessFilter.logicCenter);
	}, [warehouseCdList, WMS2020_R01ProcessFilter.logicCenter]);

    return (
        <div className="w-full">
            <InfoSectionDoubleForm buttonText="조회" >
                {/* 물류센터 선택 */}
                <SearchDropDownForm<SysCodeDto>
                    label="이동물류센터"
                    value={WMS2020_R01ProcessFilter.logicCenter}
                    optionList={wmsCdList}
                    onChangeValue={(v) =>
                        setWMS2020_R01ProcessFilter({
                            logicCenter: v === "all" ? "" : v,
                        })
                    }
                />

                {/* 창고 선택 */}
                <SearchDropDownForm<WareHouseDto>
                    label="이동창고"
                    value={WMS2020_R01ProcessFilter.warehouseCd}
                    optionList={warehouseCdListToUse}
                    onChangeValue={(v) =>
                        setWMS2020_R01ProcessFilter({
                        warehouseCd: v === "all" ? "" : v,
                        })
                    }
                />
				<SearchRadioButtonForm
					title="전송타입"
					titleValueMap={processTypeMap_WMS2020_R01}
					value={WMS2020_R01ProcessFilter.processType ?? ''}
					name="processType"
					editable={true}
					onChange={(e) => { setWMS2020_R01ProcessFilter({ processType: e.target.value }) }}
				/>
            </InfoSectionDoubleForm>
        </div>
    );
};
